import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Footer } from './components/Footer';
import { Navbar } from './components/Navbar';
import { ScrollToTop } from './components/ScrollToTop';
import { AboutUs } from './pages/AboutUs';
import { Home } from './pages/Home';
import { IngredientsPage } from './pages/IngredientsPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rknoekufnov1">
      <ScrollToTop data-id="element-1" data-mp="2rk46330veygh" />
      <div className="min-h-screen w-full bg-ivory text-forest-deep" data-id="element-2" data-mp="2rlp1svyx8nfx">
        <Navbar data-id="element-3" data-mp="2mmcc83go129n" />
        <Routes data-id="element-4" data-mp="2mmvk0rclqa9y">
          <Route path="/" element={<Home data-id="element-6" data-mp="2mjzmh44o1nm1" />} data-id="element-5" data-mp="2mndryl8mmcxp" />
          <Route path="/about" element={<AboutUs data-id="element-8" data-mp="31bs1ff0jszn8" />} data-id="element-7" data-mp="31agnwnhawdix" />
          <Route path="/ingredients" element={<IngredientsPage data-id="element-10" data-mp="2wk0bn6p7uxy5" />} data-id="element-9" data-mp="31c9y2cr4hfvo" />
          <Route path="*" element={<Home data-id="element-12" data-mp="2wifgbev2vaz8" />} data-id="element-11" data-mp="2wjqkvgwckmre" />
        </Routes>
        <Footer data-id="element-13" data-mp="28ufpyg1ohml6" />
      </div>
    </BrowserRouter>;
}